"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
const core_1 = require("@material-ui/core");
const react_1 = __importDefault(require("react"));
const TGPageLabelWrapper_1 = __importDefault(require("./TGPageLabelWrapper"));
const TGPageTextField = props => {
    var _a;
    const { readOnly, computed, oneLine, translateFunction = text => text } = props;
    const label = (react_1.default.createElement(TGPageLabelWrapper_1.default, { required: props.required, readOnly: readOnly, label: props.label, info: props.info, calculated: computed, oneLine: oneLine, translateFunction: translateFunction }));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Typography, { style: {
                wordWrap: 'break-word',
                fontFamily: 'Roboto,Roboto-Light',
            }, component: "div" },
            react_1.default.createElement("div", { style: Object.assign({ margin: 0, fontWeight: 300, fontSize: 14, lineHeight: '130%' }, (props.truncate
                    ? {
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                    }
                    : undefined)) },
                label,
                react_1.default.createElement("span", { style: props.value ? undefined : { color: '#AAAAAA', fontFamily: 'Roboto,Roboto-Light' } }, ((_a = props.value) === null || _a === void 0 ? void 0 : _a.toString()) || '(None)')))));
};
exports.default = TGPageTextField;
//# sourceMappingURL=TGPageTextField.js.map